/**
 * Stellaria theme preset: Material 3 colour roles mapped onto the Stellaria design-system tokens.
 * GENERATED by tools/design/generate-stellaria-theme.py from design/stellaria-design-system/css/tokens.css (v1.0.0).
 * Do not edit by hand; regenerate after a token change.
 */
export const STELLARIA_MATERIAL_COLOURS = {
  dark: {
    "primary": "#005CE4",
    "on-primary": "#F9FAFC",
    "primary-container": "#0038B0",
    "on-primary-container": "#F9FAFC",
    "inverse-primary": "#277DFF",
    "secondary": "#B4B8BE",
    "on-secondary": "#030409",
    "secondary-container": "#0B1016",
    "on-secondary-container": "#F9FAFC",
    "tertiary": "#3BACDA",
    "on-tertiary": "#030409",
    "tertiary-container": "#131921",
    "on-tertiary-container": "#F9FAFC",
    "error": "#D40924",
    "on-error": "#F9FAFC",
    "error-container": "#0B1016",
    "on-error-container": "#FF4D5E",
    "background": "#030409",
    "on-background": "#F9FAFC",
    "surface": "#030409",
    "on-surface": "#F9FAFC",
    "surface-variant": "#0B1016",
    "on-surface-variant": "#B4B8BE",
    "surface-dim": "#010205",
    "surface-bright": "#131921",
    "surface-container-lowest": "#010205",
    "surface-container-low": "#05070D",
    "surface-container": "#06090F",
    "surface-container-high": "#0B1016",
    "surface-container-highest": "#131921",
    "surface-tint": "#005CE4",
    "inverse-surface": "#F9FAFC",
    "inverse-on-surface": "#030409",
    "outline": "#102E62",
    "outline-variant": "#1A1E25",
    "shadow": "#010205",
    "scrim": "#010205",
    "primary-fixed": "#0038B0",
    "primary-fixed-dim": "#005CE4",
    "on-primary-fixed": "#F9FAFC",
    "on-primary-fixed-variant": "#F9FAFC",
    "secondary-fixed": "#0B1016",
    "secondary-fixed-dim": "#06090F",
    "on-secondary-fixed": "#F9FAFC",
    "on-secondary-fixed-variant": "#B4B8BE",
    "tertiary-fixed": "#131921",
    "tertiary-fixed-dim": "#0B1016",
    "on-tertiary-fixed": "#F9FAFC",
    "on-tertiary-fixed-variant": "#B4B8BE",
  },
  light: {
    "primary": "#005CE4",
    "on-primary": "#F9FAFC",
    "primary-container": "#002AA3",
    "on-primary-container": "#F9FAFC",
    "inverse-primary": "#0048CF",
    "secondary": "#2F3339",
    "on-secondary": "#F6F9FC",
    "secondary-container": "#E8EBF0",
    "on-secondary-container": "#0E1217",
    "tertiary": "#007EB3",
    "on-tertiary": "#F6F9FC",
    "tertiary-container": "#DEE1E7",
    "on-tertiary-container": "#0E1217",
    "error": "#BA0007",
    "on-error": "#F9FAFC",
    "error-container": "#E8EBF0",
    "on-error-container": "#E63B4D",
    "background": "#F6F9FC",
    "on-background": "#0E1217",
    "surface": "#F6F9FC",
    "on-surface": "#0E1217",
    "surface-variant": "#E8EBF0",
    "on-surface-variant": "#2F3339",
    "surface-dim": "#FAFCFF",
    "surface-bright": "#DEE1E7",
    "surface-container-lowest": "#FAFCFF",
    "surface-container-low": "#EFF2F6",
    "surface-container": "#EFF2F6",
    "surface-container-high": "#E8EBF0",
    "surface-container-highest": "#DEE1E7",
    "surface-tint": "#005CE4",
    "inverse-surface": "#0E1217",
    "inverse-on-surface": "#F6F9FC",
    "outline": "#80A6E3",
    "outline-variant": "#C4C8CE",
    "shadow": "#FAFCFF",
    "scrim": "#FAFCFF",
    "primary-fixed": "#002AA3",
    "primary-fixed-dim": "#005CE4",
    "on-primary-fixed": "#F9FAFC",
    "on-primary-fixed-variant": "#F9FAFC",
    "secondary-fixed": "#E8EBF0",
    "secondary-fixed-dim": "#EFF2F6",
    "on-secondary-fixed": "#0E1217",
    "on-secondary-fixed-variant": "#2F3339",
    "tertiary-fixed": "#DEE1E7",
    "tertiary-fixed-dim": "#E8EBF0",
    "on-tertiary-fixed": "#0E1217",
    "on-tertiary-fixed-variant": "#2F3339",
  },
} as const;

/** Presence colours: the design system's semantic/tactical set, so status dots stay in-palette. */
export const STELLARIA_PRESENCE = {
  online: "#4AC06C",
  idle: "#EF852E",
  busy: "#FF4D5E",
  focus: "#277DFF",
  invisible: "#8B8F97",
} as const;
